import Colors from '@/constants/Colors';
import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  &.success {
    background-color: ${Colors.success};
  }

  &.error {
    background-color: ${Colors.error};
  }

  .ant-card-body {
    padding: 0;
  }
`;
